import { RcsbFvCoreBuilder } from "./RcsbFvBuilder/RcsbFvCoreBuilder";
import { RcsbFvChromosomeBuilder } from "./RcsbFvBuilder/RcsbFvChromosomeBuilder";
import { RcsbFvPairwiseAligmentBuilder } from "./RcsbFvBuilder/RcsbFvPairwiseAligmentBuilder";
import { RcsbFvUniprotBuilder } from "./RcsbFvBuilder/RcsbFvUniprotBuilder";
import { RcsbFvEntityBuilder } from "./RcsbFvBuilder/RcsbFvEntityBuilder";
import { RcsbFvInstanceBuilder } from "./RcsbFvBuilder/RcsbFvInstanceBuilder";
import { RcsbFvProteinSequenceBuilder } from "./RcsbFvBuilder/RcsbFvProteinSequenceBuilder";
import { RcsbFvAssemblyBuilder } from "./RcsbFvBuilder/RcsbFvAssemblyBuilder";
import { GroupProvenanceId } from "@rcsb/rcsb-api-tools/lib/RcsbDw/Types/DwEnums";
import { RcsbFvGroupTabsBuilder } from "./RcsbFvGroup/RcsbFvGroupTabsBuilder";
import { RcsbFvGroupAlignmentBuilder } from "./RcsbFvBuilder/RcsbFvGroupAlignmentBuilder";
import { RcsbFvDataProviderBuilder } from "./RcsbFvBuilder/RcsbFvDataProviderBuilder";
export function unmount(elementId) {
    RcsbFvCoreBuilder.unmount(elementId);
}
export function buildMultipleAlignmentSequenceFv(elementFvId, elementSelectId, upAcc, config = {}, additionalConfig) {
    return RcsbFvUniprotBuilder.buildUniprotMultipleEntitySequenceFv(elementFvId, elementSelectId, upAcc, config, additionalConfig);
}
export function buildEntitySummaryFv(elementFvId, elementSelectId, entityId, additionalConfig) {
    return RcsbFvEntityBuilder.buildEntitySummaryFv(elementFvId, elementSelectId, entityId);
}
export function buildSingleEntitySummaryFv(elementId, entityId) {
    return RcsbFvEntityBuilder.buildSingleEntitySummaryFv(elementId, entityId);
}
export function buildInstanceSequenceFv(elementFvId, elementSelectId, entryId, config = {}, additionalConfig) {
    return RcsbFvInstanceBuilder.buildInstanceSequenceFv(elementFvId, elementSelectId, entryId, config, additionalConfig);
}
export function buildMultipleInstanceSequenceFv(elementFvId, elementEntrySelectId, elementInstanceSelectId, entryIdList, config = {}, additionalConfig) {
    return RcsbFvInstanceBuilder.buildMultipleInstanceSequenceFv(elementFvId, elementEntrySelectId, elementInstanceSelectId, entryIdList, config, additionalConfig);
}
export function buildAssemblySequenceFv(elementFvId, elementSelectAssemblyId, elementSelectInstanceId, entryId, onAsseblyChangeCallback, onInstanceChangeCallback) {
    return RcsbFvAssemblyBuilder.buildAssemblySequenceFv(elementFvId, elementSelectAssemblyId, elementSelectInstanceId, entryId, onAsseblyChangeCallback, onInstanceChangeCallback);
}
export function buildUniprotFv(elementId, upAcc, additionalConfig) {
    return RcsbFvUniprotBuilder.buildUniprotFv(elementId, upAcc, additionalConfig);
}
export function buildEntityFv(elementId, entityId, additionalConfig) {
    return RcsbFvEntityBuilder.buildEntityFv(elementId, entityId, additionalConfig);
}
export function buildInstanceFv(elementId, instanceId, additionalConfig) {
    return RcsbFvInstanceBuilder.buildInstanceFv(elementId, instanceId, additionalConfig);
}
export function buildUniprotEntityFv(elementId, upAcc, entityId, additionalConfig) {
    return RcsbFvUniprotBuilder.buildUniprotEntityFv(elementId, upAcc, entityId, additionalConfig);
}
export function buildUniprotEntityInstanceFv(elementId, upAcc, entityId, instanceId, additionalConfig) {
    return RcsbFvUniprotBuilder.buildUniprotEntityInstanceFv(elementId, upAcc, entityId, instanceId, additionalConfig);
}
export function buildPfv(elementId, config) {
    return RcsbFvProteinSequenceBuilder.buildPfv(elementId, config);
}
export function buildPairwiseAlignment(elementId, psa, additionalConfig) {
    return RcsbFvPairwiseAligmentBuilder.buildPairwiseAlignment(elementId, psa, additionalConfig);
}
export function buildFullChromosome(elementFvId, chrId) {
    return RcsbFvChromosomeBuilder.buildFullChromosome(elementFvId, chrId);
}
export function buildEntryChromosome(elementFvId, entitySelectId, chromosomeSelectId, entryId) {
    return RcsbFvChromosomeBuilder.buildEntryChromosome(elementFvId, entitySelectId, chromosomeSelectId, entryId);
}
export function buildEntityChromosome(elementFvId, elementSelectId, entityId) {
    return RcsbFvChromosomeBuilder.buildEntityChromosome(elementFvId, elementSelectId, entityId);
}
export function buildChromosome(elementFvId, entityId, chrId, elementSelectId) {
    return RcsbFvChromosomeBuilder.buildChromosome(elementFvId, chrId, elementSelectId);
}
export function buildGroupFv(elementId, groupProvenanceId, groupId, query, additionalConfig) {
    RcsbFvGroupTabsBuilder.buildGroupTabs(elementId, groupProvenanceId, groupId, query, additionalConfig);
}
export function buildSequenceIdentityAlignmentFv(elementId, groupId, query, additionalConfig) {
    return RcsbFvGroupAlignmentBuilder.buildGroupAlignmentFv(elementId, GroupProvenanceId.ProvenanceSequenceIdentity, groupId, query, additionalConfig);
}
export function buildUniprotAlignmentFv(elementId, upAcc, query, additionalConfig) {
    return RcsbFvGroupAlignmentBuilder.buildGroupAlignmentFv(elementId, GroupProvenanceId.ProvenanceMatchingUniprotAccession, upAcc, query, additionalConfig);
}
export function buildDataProviderFv(elementId, dataProvider, additionalConfig) {
    return RcsbFvDataProviderBuilder.buildFv(elementId, Object.assign(Object.assign({}, additionalConfig), { dataProvider: Object.assign({}, dataProvider) }));
}
//# sourceMappingURL=RcsbFvBuilder.js.map